<template>
  <div class="deductionTemplate">
    <el-table :data="templateData" style="width: 100%" border highlight-current-row  :header-cell-class-name="must" >
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column> 
      <el-table-column label="检查标准" min-width="200" prop="Title" header-align="center">
      </el-table-column> 
      <el-table-column label="计分规则名称" prop="CaculatePolicyName" width="200" header-align="center">
      </el-table-column> 
      <el-table-column label="描述" width="200" prop="Description" header-align="center">
      </el-table-column>
      <el-table-column label="得分" width="100" align="center">
        <template slot-scope="scoped">
          {{scoped.row.AnswerContent?scoped.row.AnswerContent.Grade:'-'}}
        </template>
      </el-table-column>
      <el-table-column label="计分" width="100" prop="Score" align="center" header-align="center">
      </el-table-column> 
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'deductionTemplate',
  components: {},
  props: {
    templateData: {},
    codeRuleType: Array,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    addTemplate(row) {
      if (row.row.childItem) {
        row.row.childItem.push({ name: '', childItem: [] });
      } else {
        this.$set(row.row, 'childItem', [{ name: '', childItem: [] }]);
      }
    },
    deleteRow(idx) {
      this.$emit('deleteQuestion', this.templateData[idx].KeyId);
      this.templateData.splice(idx, 1);
    },
    addHandle(val) {},
    modifyQuestion(row) {
      row.Changed = true;
    },
    must() {},
  },
};
</script>
<style lang="scss" scoped>
.deductionTemplate {
}
</style>
